import {useCallback, useMemo, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Carousel, CarouselGameCard, HeadingCarousel} from "@/components";
import {POPULAR_THEMES} from "@/constants/popularThemes";
import {useAuthStore} from "@/store/useAuth.store";
import {useMiniGames} from "@/store/useMiniGames";
import styles from "./ThemesCarousel.module.css";

const ThemesCarousel = () => {
  const allGames = useMiniGames(state => state.list);
  const setStoreSearch = useMiniGames(state => state.setSearch);
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);
  const [carouselApi, setCarouselApi] = useState(null);

  const themes = useMemo(
    () =>
      POPULAR_THEMES.map(theme => {
        const count = allGames.filter(game => {
          if (theme.filterClass) return game.class?.toLowerCase() === theme.filterClass;
          if (theme.filterName) return game.name?.toLowerCase().includes(theme.filterName);
          return false;
        }).length;
        return {...theme, count};
      }).filter(t => t.count > 0),
    [allGames]
  );

  const handleThemeClick = useCallback(
    theme => {
      if (authStatus !== "authenticated") {
        handleShowAuthModal();
        return;
      }
      const searchTerm = theme.filterName || theme.filterClass || theme.label;
      setStoreSearch(searchTerm);
      navigate("/gameslist/all");
    },
    [authStatus, handleShowAuthModal, setStoreSearch, navigate]
  );

  if (themes.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      <HeadingCarousel
        title="Los Más Buscados"
        icon="🔥"
        showArrowsOnMobile
        onPrev={carouselApi?.scrollPrev}
        onNext={carouselApi?.scrollNext}
      />
      <Carousel
        autoScroll={false}
        onInit={setCarouselApi}
      >
        {themes.map(theme => (
          <CarouselGameCard
            key={theme.id}
            name={theme.label}
            icon={`/images/themes/${theme.id}.jpg`}
            providerLabel={`${theme.count} juegos`}
            onClick={() => handleThemeClick(theme)}
          />
        ))}
      </Carousel>
    </div>
  );
};

export default ThemesCarousel;
